const CLOSED_STATUSES = new Set(['cancelled', 'refunded', 'voided']);

export function isOrderOpenForChat(order) {
  if (!order || order.voided_at) return false;
  if (CLOSED_STATUSES.has(order.status)) return false;
  if (!order.received_at && !order.buyer_marked_received) return true;
  if (!order.received_at) return false;
  const hoursSinceReceived = (Date.now() - new Date(order.received_at)) / (1000 * 60 * 60);
  return hoursSinceReceived < 24;
}

export function sameOrderParticipants(a, b) {
  if (!a || !b) return false;
  return (
    (a.seller_id === b.seller_id && a.buyer_id === b.buyer_id) ||
    (a.seller_id === b.buyer_id && a.buyer_id === b.seller_id)
  );
}

/** Lock only after a completed job ages out — never while an accepted/in-progress order exists. */
export function isConversationChatLocked(order, hasActiveOrder = false) {
  if (hasActiveOrder || isOrderOpenForChat(order)) return false;
  if (!order?.received_at && !order?.buyer_marked_received) return false;
  if (!order?.received_at) return false;
  const hoursSinceReceived = (Date.now() - new Date(order.received_at)) / (1000 * 60 * 60);
  return hoursSinceReceived >= 24;
}
